var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showGlobalSelector)?_c('div',{staticClass:"global-user-type-bar"},[_c('div',{staticClass:"container-wrap"},[_c('user-type-selector')],1)]):_vm._e(),_c('router-view',{key:_vm.routerViewKey})],1)}
var staticRenderFns = []

export { render, staticRenderFns }